import script from "./TrustedBySlide.vue?vue&type=script&setup=true&lang=js"
export * from "./TrustedBySlide.vue?vue&type=script&setup=true&lang=js"

import "./TrustedBySlide.vue?vue&type=style&index=0&id=3b86bdfe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b86bdfe"]])

export default __exports__